import React from "react";
import MarkdownView from "react-showdown";

import { useGql } from "../Core/gqlHooks";
import { queryPageSoinsCuirChevelu } from "../Core/services";
import PageLayout from "../Components/pageLayout/PageLayout";
import { usePageSeo } from "../Core/utils";

import "./SoinsCuirChevelu.scss";

const SoinsCuirChevelu = () => {
  const { data, loading } = useGql({
    query: queryPageSoinsCuirChevelu,
  });

  const page = data?.soinsCuirChevelu?.data?.attributes;

  usePageSeo({
    title: page?.pageTitle,
    keywords: page?.keywords,
    description: page?.metaDescription,
  });

  return (
    <PageLayout
      className="soins-cuir-chevelu-container"
      contentClassName="soins-cuir-chevelu"
      title={page?.title}
    >
      {!loading && <MarkdownView markdown={page?.Description} />}
    </PageLayout>
  );
};

export default SoinsCuirChevelu;
